// extracted by css-extract-rspack-plugin
export default {"applicationDetailsContainer":"ValidationSubmissionDetailsContainer_applicationDetailsContainer__pJhO6"};